// E1 — the "register a claim" page (its own route /claims/new). The form's own
// field labels and errors stay under `claims.create.*`, which both this page and
// the list already share; only the page-shell wording lives here.
module.exports = {
  ar: {
    claimForm: {
      crumbNew: 'مطالبة جديدة',
      backToList: '‹ رجوع لكل المطالبات',
      loading: 'جارٍ تحميل الموظفين والبوالص…',
      loadError: 'تعذّر تحميل بيانات الموظفين أو البوالص — ارجع لقائمة المطالبات وجرّب تاني.',
      goToList: 'روح لقائمة المطالبات',
      partialHint:
        'المطالبة اتسجلت بنجاح، بس في مرفقات مرفعتش. سجّلها عندك وارفعها تاني من صفحة المطالبة — مش محتاج تسجّل المطالبة من الأول.',
    },
  },
  en: {
    claimForm: {
      crumbNew: 'New claim',
      backToList: '‹ Back to all claims',
      loading: 'Loading employees and policies…',
      loadError: 'Could not load employees or policies — go back to the claims list and try again.',
      goToList: 'Go to the claims list',
      partialHint:
        'The claim was registered, but some attachments did not upload. Note them down and re-upload from the claim page — there is no need to register the claim again.',
    },
  },
};
